import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnPlacesAutocompleteTemplateOptions } from './places-autocomplete-template-options.interface';

export interface ISnPlacesAutocompleteFormFieldConfig extends FormlyFieldConfig {
  type: 'places-autocomplete';
  templateOptions: ISnPlacesAutocompleteTemplateOptions;
}
